import { ref } from "vue";

type OtaListObject = {
  id: number;
  label: string;
};

export default function useCheck() {
  const arrSelected = ref<number[]>([]);
  const objectArrSelected = ref<OtaListObject[]>([]);

  const resetSelection = () => {
    arrSelected.value = [];
    objectArrSelected.value = [];
  };

  return {
    arrSelected,
    objectArrSelected,
    resetSelection,
  };
}
